import { render, staticRenderFns } from "./AjusteParametrosDialog.vue?vue&type=template&id=998d6e16"
import script from "./AjusteParametrosDialog.vue?vue&type=script&lang=js"
export * from "./AjusteParametrosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports